import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Badge,
  Table,
} from "react-bootstrap";
import { MdCurrencyRupee } from "react-icons/md";
import { getpackage } from "../../store/slices/package";
import { getLeadActivity } from "../../store/slices/leads";
import { getupcomingBookings, getBookings } from "../../store/slices/booking";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import Kashmir from "../../assets/kashmir.jpg";
import { getLead } from "../../store/slices/leads";
import moment from "moment";


import { FaSyncAlt, FaStar } from "react-icons/fa";

export default function Dashboard() {
  const [packages, setPackages] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activities, setActivities] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(true);
  const [loadingActivities, setLoadingActivities] = useState(true);
  const [loadingBookings, setLoadingBookings] = useState(true);
  const [loadingUpcoming, setLoadingUpcoming] = useState(true);
  const [totalBookings, setTotalBookings] = useState(0);
  const [totalLeads, setTotalLeads] = useState(0);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setLoadingPackages(true);
        let item = { limit: 3 }
        const res = await dispatch(getpackage(item)).unwrap();
        setPackages(res?.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingPackages(false);
      }
    };
    fetchPackages();
  }, [dispatch]);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        setLoadingActivities(true);
        const res = await dispatch(getLeadActivity()).unwrap();
        setActivities(res.activities || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingActivities(false);
      }
    };
    fetchActivities();
  }, [dispatch]);

  useEffect(() => {
    const fetchUpcomingBookings = async () => {
      try {
        setLoadingUpcoming(true);
        const res = await dispatch(getupcomingBookings()).unwrap();
        setUpcomingBookings(res.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingUpcoming(false);
      }
    };
    fetchUpcomingBookings();
  }, [dispatch]);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoadingBookings(true);
        const res = await dispatch(getBookings()).unwrap();
        setBookings(res?.data || []);
        setTotalBookings(res?.total || 0);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingBookings(false);
      }
    };
    fetchBookings();
  }, [dispatch]);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const res = await dispatch(getLead()).unwrap();

        setTotalLeads(
          res?.total || 0
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchLeads();
  }, [dispatch]);
  const datapack = {
    stats: [
      {
        title: "Total Booking",
        value: totalBookings,
        positive: true,
        icon: <FaCalendarAlt size={18} />,
      },
      {
        title: "Total Leads",
        value: totalLeads,
        positive: false,
        icon: <FaUsers size={18} />,
      },
      {
        title: "Total Earnings",
        value: "₹0",
        positive: true,
        icon: <MdCurrencyRupee size={18} />,
      },
    ],
  };

  return (
    <Container fluid className="dashboard-page">
      <Row className="g-4">

        {/* ================= LEFT COLUMN ================= */}
        <Col lg={8}>

          {/* ================= STATS ================= */}
          <Row className="g-3 mb-1">
            {datapack.stats.map((item, i) => (
              <Col md={4} key={i}>
                <div className="stat-card">
                  <div className="d-flex align-items-center mb-3">
                    <div className="stat-icon me-3">
                      {item.icon}
                    </div>

                    <div className="stat-title">
                      {item.title}
                    </div>
                  </div>

                  <div className="stat-value">
                    {item.value}
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* ================= TRAVEL PACKAGES ================= */}
          <div className="dashboard-section-title mt-4">
            <h5>Travel Packages</h5>

            <button
              type="button"
              onClick={() => navigate("/admin/packages")}
              className="view-all-btn-theme"
            >
              View All →
            </button>
          </div>

          <Row className="g-3">
            {loadingPackages ? (
              Array.from({ length: 3 }).map((_, i) => (
                <Col lg={4} md={6} key={i}>
                  <Card className="package-card">
                    <div className="dashboard-skeleton package-image-wrapper" />

                    <Card.Body className="package-card-body">
                      <div className="dashboard-skeleton mb-2" style={{ height: 14, width: "80%" }} />
                      <div className="dashboard-skeleton mb-3" style={{ height: 10, width: "55%" }} />
                      <div className="dashboard-skeleton" style={{ height: 16, width: "40%" }} />
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : packages.length > 0 ? (
              packages.map((pkg, i) => (
                <Col lg={4} md={6} key={pkg?._id || i}>
                  <Card className="package-card">

                    <div className="package-image-wrapper">
                      <Card.Img
                        src={pkg?.image?.[0] || Kashmir}
                        alt={pkg?.title || "Travel Package"}
                      />

                      <div className="package-overlay" />

                      <Badge className="package-badge">
                        {pkg?.tag || "Travel Package"}
                      </Badge>
                    </div>

                    <Card.Body className="package-card-body">

                      <div className="package-card-title">
                        {pkg?.title || "Untitled Package"}
                      </div>

                      <div className="package-duration">
                        <FiCalendar />

                        {pkg?.durationNights || 0} Nights /{" "}
                        {pkg?.durationDays || 0} Days
                      </div>

                      <div className="package-price">
                        ₹{pkg?.pricing?.minPrice || 0}
                        <small> / person</small>
                      </div>

                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div className="dashboard-empty">
                  No travel packages found
                </div>
              </Col>
            )}
          </Row>

          {/* ================= RECENT BOOKINGS ================= */}
          <div className="dashboard-section-title mt-4">
            <h5>Recent Bookings</h5>

            <button
              type="button"
              onClick={() => navigate("/admin/booking")}
              className="view-all-btn-theme"
            >
              View All →
            </button>
          </div>

          <Card className="booking-card">
            <Card.Body>

              <div className="table-responsive">
                <Table hover className="booking-table">

                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Package</th>
                      <th>Duration</th>
                      <th>Date</th>
                      <th>Price</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>

                    {loadingBookings ? (
                      Array.from({ length: 5 }).map((_, i) => (
                        <tr key={i}>
                          {Array.from({ length: 6 }).map((_, j) => (
                            <td key={j}>
                              <div
                                className="dashboard-skeleton"
                                style={{
                                  height: 12,
                                  width: j === 0 ? "75%" : "60%",
                                }}
                              />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : bookings.length > 0 ? (
                      bookings.map((item) => (
                        <tr key={item?._id}>

                          <td>
                            {item?.lead?.name || "-"}
                          </td>

                          <td>
                            {item?.package?.title || "-"}
                          </td>

                          <td>
                            {item?.totalPax || "-"}
                          </td>

                          <td>
                            {item?.travelDate
                              ? moment(item.travelDate).format("DD-MM-YYYY")
                              : "-"}
                          </td>

                          <td>
                            ₹ {item?.totalAmount || 0}
                          </td>



                          <td>
                            <span className="booking-status">
                              {item?.bookingStatus || "Pending"}
                            </span>
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center"
                        >
                          <div className="dashboard-empty">
                            No bookings found
                          </div>
                        </td>
                      </tr>
                    )}

                  </tbody>
                </Table>
              </div>

            </Card.Body>
          </Card>

        </Col>


        {/* ================= RIGHT COLUMN ================= */}
        <Col lg={4}>
          <div className="dashboard-right-column">

            {/* ================= UPCOMING TRIPS ================= */}
            <Card className="upcoming-card">
              <Card.Body>

                <div className="dashboard-section-title mb-2">
                  <h5>Upcoming Trips</h5>
                </div>

                {loadingUpcoming ? (
                  Array.from({ length: 3 }).map((_, i) => (
                    <div
                      key={i}
                      className="trip-item"
                    >
                      <div
                        className="dashboard-skeleton trip-image"
                      />

                      <div className="flex-grow-1 ms-3">
                        <div
                          className="dashboard-skeleton mb-2"
                          style={{
                            height: 12,
                            width: "70%",
                          }}
                        />

                        <div
                          className="dashboard-skeleton"
                          style={{
                            height: 9,
                            width: "40%",
                          }}
                        />
                      </div>
                    </div>
                  ))
                ) : upcomingBookings.length > 0 ? (
                  upcomingBookings.map((item) => (
                    <div
                      key={item?._id}
                      className="trip-item"
                    >

                      <Image
                        src={
                          item?.package?.image?.[0] ||
                          Kashmir
                        }
                        className="trip-image"
                      />

                      <div className="ms-3 flex-grow-1">

                        <div className="trip-title">
                          {item?.package?.title ||
                            "Package"}
                        </div>

                        <div className="trip-date">
                          <FiCalendar />

                          {item?.travelDate
                            ? moment(item.travelDate).format("DD-MM-YYYY")
                            : "-"}
                        </div>

                      </div>

                    </div>
                  ))
                ) : (
                  <div className="dashboard-empty">
                    No upcoming bookings
                  </div>
                )}

              </Card.Body>
            </Card>


            {/* ================= RECENT ACTIVITY ================= */}
            <Card className="activity-card">
              <Card.Body>

                <div className="dashboard-section-title mb-2">
                  <h5>Recent Activity</h5>
                </div>

                {loadingActivities ? (
                  Array.from({ length: 4 }).map((_, i) => (
                    <div
                      className="activity-item"
                      key={i}
                    >

                      <div className="activity-icon">
                        <div
                          className="dashboard-skeleton"
                          style={{
                            width: 18,
                            height: 18,
                            borderRadius: "50%",
                          }}
                        />
                      </div>

                      <div className="activity-content w-100">

                        <div
                          className="dashboard-skeleton mb-2"
                          style={{
                            height: 10,
                            width: "80%",
                          }}
                        />

                        <div
                          className="dashboard-skeleton mb-2"
                          style={{
                            height: 9,
                            width: "60%",
                          }}
                        />

                        <div
                          className="dashboard-skeleton"
                          style={{
                            height: 8,
                            width: "40%",
                          }}
                        />

                      </div>
                    </div>
                  ))
                ) : activities.length > 0 ? (
                  activities.map((item, index) => (

                    <div
                      className="activity-item"
                      key={item?._id || index}
                    >

                      <div
                        className={`activity-icon ${item?.type === "CALL"
                          ? "text-primary"
                          : item?.type === "NOTE"
                            ? "text-warning"
                            : "text-secondary"
                          }`}
                      >
                        {item?.type === "CALL" ? (
                          <FaCalendarAlt size={17} />
                        ) : item?.type === "NOTE" ? (
                          <FaStar size={17} />
                        ) : (
                          <FaSyncAlt size={17} />
                        )}
                      </div>

                      <div className="activity-content">

                        <div className="activity-title">
                          <strong>
                            {item?.createdBy?.name ||
                              "User"}
                          </strong>{" "}
                          added{" "}
                          {item?.type?.toLowerCase() ||
                            "activity"}{" "}
                          for{" "}
                          <strong>
                            {item?.lead?.name ||
                              "Lead"}
                          </strong>
                        </div>

                        <div className="activity-description">
                          {item?.description ||
                            "No description"}
                        </div>

                        <div className="activity-time">
                          {item?.createdAt
                            ? moment(item.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </div>

                      </div>

                    </div>

                  ))
                ) : (
                  <div className="dashboard-empty">
                    No recent activities found
                  </div>
                )}

              </Card.Body>
            </Card>

          </div>
        </Col>

      </Row>
    </Container>
  );
}
